import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class BaseMapWrapper {
  constructor(config) {
    _defineProperty(this, "configService", void 0);
    _defineProperty(this, "config", void 0);
    this.config = config;
  }
  setContainer(sceneContainer, id) {
    this.configService = sceneContainer.globalConfigService;
    sceneContainer.mapConfig = _objectSpread(_objectSpread({}, this.config), {}, {
      id
    });
    // @ts-ignore
    sceneContainer.mapService = new (this.getServiceConstructor())(sceneContainer);
  }
  getServiceConstructor() {
    throw new Error('Method not implemented.');
  }
}